import { YouthTogetherTheme } from "./schemes/YouthTogetherTheme";
import { GLuzTheme } from "./schemes/GLuzTheme";
import { ParadoxTheme } from "./schemes/ParadoxTheme";
import { Congreso2023Theme } from "./schemes/Congreso2023Theme";
import { GLuzNavidad2023 } from "./schemes/GLuzNavidad2023";
import { Camp2024Theme } from "./schemes/Camp2024Theme";
import { Camp2025Theme } from "./schemes/Camp2025Theme";
import { Camp2026Theme } from "./schemes/Camp2026Theme";
import { defaultTheme } from "../utils";

export function themeCreator(theme) {
  return themeMap[theme] ?? themeMap[defaultTheme];
}

const themeMap = {
  YouthTogetherTheme,
  ParadoxTheme,
  Congreso2023Theme,
  GLuzTheme,
  GLuzNavidad2023,
  Camp2024Theme,
  Camp2025Theme,
  Camp2026Theme,
};
